import { useSnapshot } from 'valtio';
import { serviceState } from '../workspace/lib/state';
import type { LiveServicesMapping } from '../workspace/lib/state';
import { getLiveServicesMappingByPhoneAndTenant } from '../workspace/lib/liveServicesMapping';

export function useLiveServicesMapping(
  phoneNumber?: string,
  tenantId?: string,
): LiveServicesMapping | undefined {
  const snap = useSnapshot(serviceState);

  if (!snap.isLiveServicesNetwork || !phoneNumber || !tenantId) {
    return undefined;
  }

  return getLiveServicesMappingByPhoneAndTenant(
    phoneNumber,
    tenantId,
    snap.liveServicesMappings,
  );
}
